var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consultation"},[_c('com-list',{attrs:{"data":_vm.coStyle,"title":"合作形式"}}),_c('co-area'),_c('com-service'),_c('com-tea'),_c('com-partner',{attrs:{"partners":_vm.partners}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }